document.addEventListener('DOMContentLoaded', function() {
  // General modal handling
  const modalTriggers = document.querySelectorAll('.request-general');
  const modals = document.querySelectorAll('.general-modal'); // Changed to match modal class
  const modalCloses = document.querySelectorAll('.modal-close');

  // Open modal when clicking trigger
  modalTriggers.forEach(trigger => {
    trigger.addEventListener('click', function() {
      const modalId = this.dataset.modal;
      const modal = document.querySelector(`.${modalId}`);
      if (modal) {
        modal.classList.add('visible');
      }
    });
  });

  // Close modal when clicking outside
  modals.forEach(modal => {
    modal.addEventListener('click', function(e) {
      if (e.target === modal) {
        modal.classList.remove('visible');
      }
    });
  });

  // Close modal when clicking close button
  modalCloses.forEach(close => {
    close.addEventListener('click', function() {
      const modal = this.closest('.general-modal'); // Changed to match modal class
      if (modal) {
        modal.classList.remove('visible');
      }
    });
  });
});